import { render } from "./PhotoGallery.vue?vue&type=template&id=266e3fa8&scoped=true&ts=true"
import script from "./PhotoGallery.vue?vue&type=script&lang=ts"
export * from "./PhotoGallery.vue?vue&type=script&lang=ts"

import "./PhotoGallery.vue?vue&type=style&index=0&id=266e3fa8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-266e3fa8"]])

export default __exports__